// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eBsMH","errorMesssage":"Footer_errorMesssage__T4OH-","noErrorMesssage":"Footer_noErrorMesssage__EVKeN"};